export default {
  tiles: [
    {
      id: 0,
      isImage: false,
      backgroundColor: '#B7ECDA',
      title: 'Consumer, Company, Team, Self',
      copy: "We lean on each other to succeed. Understanding different viewpoints and celebrating our coworkers' wins lead to stronger decisions and teams.",
    },
    {
      id: 1,
      isImage: false,
      backgroundColor: '#C8E4FE',
      title:
        'Relentless <span class="nowrap" style="white-space: pre;">Self-Improvement</span> ',
      copy: "We take responsibility for getting better every day. We humbly embrace what we don't know and aren't afraid to ask questions.",
    },
    {
      id: 2,
      isImage: false,
      backgroundColor: '#F2EDE6',
      title: 'Open, Candid, and Constructive',
      copy: 'We are active participants in every interaction. We share feedback with clarity and receive feedback with courage.',
    },
    {
      id: 3,
      isImage: true,
    },
    {
      id: 4,
      isImage: false,
      backgroundColor: '#C8E4FE',
      title: 'Informed Risk-Taking',
      copy: 'We set actionable goals that challenge the status quo, knowing it’s safe to fail so long as we learn along the way. ',
    },
    {
      id: 5,
      isImage: false,
      backgroundColor: '#B7ECDA',
      title: 'Ownership',
      copy: 'We ask, “What can I do to improve the results?” and view challenges as opportunities to find the right solution.',
    },
  ],
};
